
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getJobPaymentHistoryProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetJobPaymentHistoryProfessionalApi = createAsyncThunk(
  "hitGetJobPaymentHistoryProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getJobPaymentHistoryProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetJobPaymentHistoryProfessionalSlice = createSlice({
  name: "getJobPaymentHistoryProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetJobPaymentHistoryProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetJobPaymentHistoryProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetJobPaymentHistoryProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetJobPaymentHistoryProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetJobPaymentHistoryProfessionalData } = GetJobPaymentHistoryProfessionalSlice.actions;
export default GetJobPaymentHistoryProfessionalSlice.reducer;
